module.exports = __webpack_public_path__ + "static/media/marcos_senesi.a5cfa6b4.jpg";